/* nanobalance overlays: Spotlight search, account popup, cart drawer */
(function () {
  var $ = function (id) { return document.getElementById(id); };
  var scrim = $('nbScrim');
  var META = window.__nbMeta || {};

  function money(cents) {
    return 'Rs. ' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  // lock both html and body: depending on the page the scrolling element can be
  // either, and locking only <body> lets the page keep scrolling behind the overlay
  function lock(on) {
    var v = on ? 'hidden' : '';
    document.body.style.overflow = v;
    document.documentElement.style.overflow = v;
  }

  // ---------- generic open/close ----------
  var openPanel = null;
  function close() {
    ['nbSpot', 'nbCart', 'nbNotify'].forEach(function (id) {
      var el = $(id); if (el) el.classList.remove('is-open');
    });
    if (scrim) scrim.classList.remove('is-open');
    document.body.classList.remove('nb-overlay-open');
    lock(false);
    openPanel = null;
  }
  function open(id, useScrim) {
    close();
    var el = $(id); if (!el) return;
    el.classList.add('is-open');
    if (useScrim && scrim) scrim.classList.add('is-open');
    document.body.classList.add('nb-overlay-open');
    lock(true);
    openPanel = id;
  }
  if (scrim) scrim.addEventListener('click', close);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && openPanel) close(); });
  ['nbSpot', 'nbNotify'].forEach(function (id) {
    var el = $(id);
    if (el) el.addEventListener('click', function (e) { if (e.target === el) close(); });
  });
  var cartClose = $('nbCartClose'); if (cartClose) cartClose.addEventListener('click', close);
  var notifyClose = $('nbNotifyClose'); if (notifyClose) notifyClose.addEventListener('click', close);

  // ---------- NOTIFY ME (back in stock) ----------
  // Opens the popup with the product pre-set on the hidden Zoho field. Used by
  // the small product cards (carousel / collection / search / related), where
  // there isn't room to reveal the form inline.
  window.nbNotify = function (productTitle) {
    var hidden = $('nbNfProduct-modal');
    var form = $('nbNf-modal');
    var done = $('nbNfDone-modal');
    var sub = $('nbNotifySub');
    var label = $('nbNotifyProduct');
    // reset first, then set the product — reset() would wipe it the other way round
    if (form) { form.hidden = false; form.reset(); }
    if (hidden) hidden.value = productTitle || '';
    if (label) label.textContent = productTitle || 'this';
    if (sub) sub.hidden = false;
    if (done) done.hidden = true;
    open('nbNotify', false);
  };
  // Delegated so any card anywhere can opt in with data-nb-notify="<product title>".
  // (An inline onclick can't carry the title safely — titles contain quotes/periods.)
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-nb-notify]');
    if (!trigger) return;
    e.preventDefault();
    window.nbNotify(trigger.getAttribute('data-nb-notify'));
  });

  // Back-in-stock form submit: the browser posts natively into the hidden
  // iframe (cross-origin form POST needs no CORS, unlike fetch). We can't read
  // the opaque response, but the iframe's load event tells us it completed.
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('.nb-nf');
    if (!form) return;
    var uid = form.getAttribute('data-uid');
    var sink = document.querySelector('iframe[name="nbNfSink-' + uid + '"]');
    var done = $('nbNfDone-' + uid);
    var btn = form.querySelector('.nb-nf-btn');
    if (!sink || !done) return; // let it submit normally rather than break
    var emailField = form.querySelector('input[name="Email"]');
    var submitted = emailField ? emailField.value.trim() : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Sending…'; }
    var onLoad = function () {
      sink.removeEventListener('load', onLoad);
      // name the address so it's obvious where the alert is going
      var at = done.querySelector('.nb-nf-done-at');
      if (at) at.textContent = submitted ? ' at ' + submitted : '';
      form.hidden = true;
      done.hidden = false;
      // the "leave your email" line only makes sense while the field is up
      var sub = $('nbNotifySub');
      if (uid === 'modal' && sub) sub.hidden = true;
      if (btn) { btn.disabled = false; btn.textContent = 'Notify me'; }
      // popup only: let them read the confirmation, then close on its own.
      // The inline form on the product page has no popup, so it just stays put.
      if (uid === 'modal') {
        setTimeout(function () {
          if (openPanel === 'nbNotify') close();
        }, 2800);
      }
    };
    sink.addEventListener('load', onLoad);
  });
  var spotClose = $('nbSpotClose'); if (spotClose) spotClose.addEventListener('click', close);

  // ---------- SPOTLIGHT SEARCH ----------
  var spotInput = $('nbSpotInput');
  var spotResults = $('nbSpotResults');
  var searchTimer, activeIdx = -1;

  function docRow(d, icon) {
    var sub = d.sub ? '<span class="nbspot-sub">' + d.sub + '</span>' : '';
    return '<a class="nbspot-row" href="' + d.url + '">' +
      '<span class="nbspot-thumb nbspot-thumb--doc">' +
        (d.image ? '<img src="' + d.image + '" alt="">' : icon) +
      '</span>' +
      '<span><span class="nbspot-name">' + d.title + '</span>' + sub + '</span></a>';
  }

  function renderSearch(groups, q) {
    if (!spotResults) return;
    var items = groups.products || [];
    var articles = groups.articles || [];
    var pages = groups.pages || [];
    if (!items.length && !articles.length && !pages.length) {
      spotResults.innerHTML = '<div class="nbspot-empty">No matches.</div>' +
        '<a class="nbspot-all" href="/search?q=' + encodeURIComponent(q || '') + '">See all results →</a>';
      spotResults.classList.add('has-results');
      return;
    }
    var rows = items.map(function (p, i) {
      var m = META[p.id] || {};
      var bg = m.bg || '#f4f0fa';
      var accent = m.accent || '#131313';
      var name = m.title || (p.title || '').toLowerCase();
      var imgSrc = m.img || p.image;
      var img = imgSrc ? '<img src="' + imgSrc + '" alt="">' : '';
      var cat = m.cat ? '<span class="nbspot-cat">' + m.cat + '</span>' : '';
      var sub = m.sub ? '<span class="nbspot-sub">' + m.sub + '</span>' : '';
      var priceCents = m.price || null;
      var priceTxt = priceCents ? money(priceCents) : (p.price || '');
      var right = '<span class="nbspot-price">' + priceTxt + '</span>';
      if (m.compare && m.compare > (priceCents || 0)) right += '<span class="nbspot-compare">' + money(m.compare) + '</span>';
      if (m.available === false) right += '<span class="nbspot-soldout">Sold out</span>';
      return '<a class="nbspot-row" href="' + (m.url || p.url) + '" data-i="' + i + '">' +
        '<span class="nbspot-thumb" style="background:' + bg + '">' + img + '</span>' +
        '<span>' + cat + '<span class="nbspot-name" style="color:' + accent + '">' + name + '</span>' + sub + '</span>' +
        '<span class="nbspot-right">' + right + '</span></a>';
    }).join('');
    if (items.length) rows = '<div class="nbspot-ghead">Products</div>' + rows;
    var bookIcon = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="#8a857f" stroke-width="1.5"><path d="M4 3.5h9a2.5 2.5 0 0 1 2.5 2.5v10.5H6A2 2 0 0 1 4 14.5v-11Z"/><path d="M4 14.5A2 2 0 0 1 6 12.5h9.5"/></svg>';
    var pageIcon = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="#8a857f" stroke-width="1.5"><path d="M5 2.5h7l3 3v12H5v-15Z"/><path d="M12 2.5v3h3"/></svg>';
    if (articles.length) {
      rows += '<div class="nbspot-ghead">Journal</div>' + articles.map(function (a) { return docRow(a, bookIcon); }).join('');
    }
    if (pages.length) {
      rows += '<div class="nbspot-ghead">Pages</div>' + pages.map(function (p) { return docRow(p, pageIcon); }).join('');
    }
    rows += '<a class="nbspot-all" href="/search?q=' + encodeURIComponent(q || '') + '">See all results →</a>';
    spotResults.innerHTML = rows;
    spotResults.classList.add('has-results');
    activeIdx = -1;
  }

  function doSearch(q) {
    if (!q.trim()) { spotResults.classList.remove('has-results'); spotResults.innerHTML = ''; return; }
    fetch('/search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product,article,page&resources[limit]=5&resources[limit_scope]=each&resources[options][unavailable_products]=last',
      { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var res = ((d.resources || {}).results || {});
        renderSearch({
          products: (res.products || []).map(function (p) {
            return {
              id: p.id, title: p.title, url: p.url, image: p.featured_image ? p.featured_image.url : null,
              price: p.price ? money(Math.round(parseFloat(p.price) * 100)) : '', type: p.type || ''
            };
          }),
          articles: (res.articles || []).map(function (a) {
            return { title: a.title, url: a.url, image: a.image, sub: a.summary_html ? String(a.summary_html).replace(/<[^>]*>/g, '').slice(0, 80) : '' };
          }),
          pages: (res.pages || []).map(function (p) {
            return { title: p.title, url: p.url, image: null, sub: '' };
          })
        }, q);
      })
      .catch(function () { spotResults.classList.remove('has-results'); });
  }

  if (spotInput) {
    spotInput.addEventListener('input', function () {
      clearTimeout(searchTimer);
      var q = spotInput.value;
      searchTimer = setTimeout(function () { doSearch(q); }, 180);
    });
    spotInput.addEventListener('keydown', function (e) {
      var rows = spotResults.querySelectorAll('.nbspot-row');
      if (!rows.length) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        activeIdx += (e.key === 'ArrowDown' ? 1 : -1);
        if (activeIdx < 0) activeIdx = rows.length - 1;
        if (activeIdx >= rows.length) activeIdx = 0;
        rows.forEach(function (r) { r.classList.remove('is-active'); });
        rows[activeIdx].classList.add('is-active');
        rows[activeIdx].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter' && activeIdx > -1) {
        e.preventDefault();
        window.location.href = rows[activeIdx].getAttribute('href');
      }
    });
  }

  window.nbOpenSearch = function () {
    open('nbSpot', false);
    if (!spotInput) return;
    // Focus synchronously, still inside the tap gesture. A deferred focus()
    // (setTimeout) is ignored by mobile browsers, so the keyboard never opens.
    // Reading offsetWidth flushes styles first so the input is already visible
    // — .focus() is a no-op on a visibility:hidden element.
    void spotInput.offsetWidth;
    try { spotInput.focus({ preventScroll: true }); } catch (err) { spotInput.focus(); }
    // fallback for anything that lost the race with the opening transition
    setTimeout(function () {
      if (document.activeElement !== spotInput) spotInput.focus();
    }, 80);
  };
  // ---------- CART DRAWER ----------
  var cartItems = $('nbCartItems');
  var cartCount = $('nbCartCount');
  var cartSub = $('nbCartSubtotal');
  var cartSaved = $('nbCartSaved');
  var discForm = $('nbCartDiscForm');
  var discInput = $('nbCartDiscInput');
  var discBtn = $('nbCartDiscBtn');
  var discMsg = $('nbCartDiscMsg');
  var discTag = $('nbCartDiscTag');
  var discCode = $('nbCartDiscCode');
  var discAmt = $('nbCartDiscAmt');
  var discRemove = $('nbCartDiscRemove');

  function itemRow(it) {
    var m = META[it.product_id] || {};
    var bg = m.bg || '#f4f0fa';
    var accent = m.accent || '#131313';
    var img = it.image ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') + '" alt="">' : '';
    var compare = (m.compare && m.compare > it.price) ? '<div class="nbci-compare">' + money(m.compare * it.quantity) + '</div>' : '';
    return '<div class="nbci" data-key="' + it.key + '">' +
      '<span class="nbci-thumb" style="background:' + bg + '">' + img + '</span>' +
      '<div class="nbci-mid">' +
        '<a class="nbci-name" style="color:' + accent + '" href="' + it.url + '">' + (it.product_title || it.title) + '</a>' +
        '<div class="nbci-meta">' + (it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : 'One-time') + '</div>' +
        '<div class="nbci-qty">' +
          '<button type="button" data-act="dec" aria-label="Decrease">−</button>' +
          '<span class="nbci-n">' + it.quantity + '</span>' +
          '<button type="button" data-act="inc" aria-label="Increase">+</button>' +
        '</div>' +
      '</div>' +
      '<div class="nbci-right"><div class="nbci-price">' + money(it.line_price) + '</div>' + compare + '</div>' +
    '</div>';
  }

  function upsellRow(cart) {
    var inCart = {};
    cart.items.forEach(function (i) { inCart[i.product_id] = true; });
    var pick = null;
    Object.keys(META).forEach(function (pid) {
      if (!pick && !inCart[pid] && META[pid].available && META[pid].vid) pick = { pid: pid, m: META[pid] };
    });
    if (!pick) return '';
    var m = pick.m;
    var img = m.img ? '<img src="' + m.img + '" alt="">' : '';
    return '<div class="nbcart-updiv"><span>ADD &amp; SAVE</span><i></i></div>' +
      '<div class="nbcart-up">' +
        '<span class="nbci-thumb" style="background:' + m.bg + '">' + img + '</span>' +
        '<div class="nbci-mid"><a class="nbci-name" style="color:' + m.accent + ';font-size:14px" href="' + m.url + '">' + m.title + '</a>' +
        '<div class="nbci-meta">Complete the stack</div></div>' +
        '<button type="button" class="nbcart-upadd" data-vid="' + m.vid + '">+ ' + money(m.price) + '</button>' +
      '</div>';
  }

  function renderCart(cart) {
    if (!cartItems) return;
    if (cartCount) cartCount.textContent = cart.item_count ? '· ' + cart.item_count + (cart.item_count === 1 ? ' item' : ' items') : '';
    if (cartSub) cartSub.textContent = money(cart.total_price);

    var saved = 0;
    cart.items.forEach(function (it) {
      var m = META[it.product_id];
      if (m && m.compare && m.compare > it.price) saved += (m.compare - it.price) * it.quantity;
    });
    if (cartSaved) {
      if (saved > 0) { cartSaved.textContent = 'You saved ' + money(saved) + ' on this order 🎉'; cartSaved.classList.add('show'); }
      else cartSaved.classList.remove('show');
    }

    var discWrap = $('nbCartDisc');
    if (discWrap) discWrap.style.display = cart.items.length ? '' : 'none';
    renderDiscount(cart);

    if (!cart.items.length) {
      cartItems.innerHTML = '<div class="nbcart-empty">Your stack is empty.</div>';
      return;
    }
    cartItems.innerHTML = cart.items.map(itemRow).join('') + upsellRow(cart);
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); syncBubble(cart); return cart; });
  }
  function syncBubble(cart) {
    document.querySelectorAll('[id^="nbhCount-"]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? '' : 'none';
    });
  }
  // /cart/change.js answers with a stubbed cart_level_discount_applications (an
  // empty object, no title or amount), so its response can't be used to decide
  // discount state. fetchCart re-reads /cart.js, which is authoritative.
  function changeLine(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, qty) })
    }).then(function () { return fetchCart(); });
  }

  // ---------- DISCOUNT CODES ----------
  // /cart/update.js takes a `discount` param, but two behaviours force care:
  // its own response doesn't reliably carry the code back (a valid apply came
  // back with a null title), and an invalid code silently drops whichever valid
  // code was already on the cart. So always verify against /cart.js afterwards,
  // and put the previous code back when the new one doesn't take.
  // These mirror the SLABS table in the nb-tiered-discount Shopify Function
  // (extensions/nb-tiered-discount/src/cart_lines_discounts_generate_run.js).
  // A storefront can't read a discount function's config, so if the entry
  // conditions change there, they have to change here too.
  var DISC_MIN_ITEMS = 2;
  var DISC_MIN_SUBTOTAL = 100000; // ₹1,000, in paise

  function cartCodes(cart) {
    return (cart.cart_level_discount_applications || [])
      .filter(function (d) { return d.title; })
      .map(function (d) { return d.title; });
  }

  // A code sits on the cart in one of three states. Shopify keeps a code that
  // doesn't qualify yet, marked applicable:false, and applies it by itself once
  // the cart grows into it — so "pending" is a real, useful state, not an error.
  function discountState(cart) {
    var applied = (cart.cart_level_discount_applications || []).filter(function (d) { return d.title; });
    if (applied.length) {
      return { status: 'applied', code: applied[0].title, amount: applied[0].total_allocated_amount };
    }
    var pending = (cart.discount_codes || []).filter(function (c) { return c.code; });
    if (pending.length) return { status: 'pending', code: pending[0].code };
    return { status: 'none' };
  }

  // Why a code hasn't taken. Returns null when the cart already meets every
  // condition — which means the code itself is the problem, not the cart.
  // Deliberately names only the unmet condition rather than printing the whole
  // slab table, so a stranger guessing codes learns nothing about the scheme.
  function pendingReason(cart) {
    var items = cart.item_count || 0;
    var sub = cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price;
    if (items < DISC_MIN_ITEMS) {
      var need = DISC_MIN_ITEMS - items;
      return 'Needs at least ' + DISC_MIN_ITEMS + ' items — add ' + need + ' more and it applies automatically.';
    }
    if (sub < DISC_MIN_SUBTOTAL) {
      return 'Starts at ' + money(DISC_MIN_SUBTOTAL) + ' — add ' + money(DISC_MIN_SUBTOTAL - sub) +
        ' more and it applies automatically.';
    }
    return null;
  }
  function putDiscount(code) {
    return fetch('/cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: code })
    }).then(function () {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    }).then(function (r) { return r.json(); });
  }

  window.nbDiscount = {
    codes: cartCodes,
    state: discountState,
    reason: pendingReason,
    // Resolves to one of:
    //   {status:'applied'}  the code took, cart is discounted
    //   {status:'pending'}  real conditions aren't met yet; code stays on the
    //                       cart and Shopify applies it when they are
    //   {status:'rejected'} cart already qualifies, so the code is wrong
    apply: function (code) {
      code = (code || '').trim();
      if (!code) return Promise.resolve({ status: 'rejected', cart: null });
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (before) {
          var prev = cartCodes(before);
          return putDiscount(code).then(function (cart) {
            var took = cartCodes(cart).some(function (c) {
              return c.toUpperCase() === code.toUpperCase();
            });
            if (took) return { status: 'applied', cart: cart };

            var why = pendingReason(cart);
            if (why) {
              // The cart is the reason. Keeping a working code would be better
              // than a pending one, so only hold the new code when nothing was
              // already applied.
              if (prev.length) {
                return putDiscount(prev[0]).then(function (restored) {
                  return { status: 'rejected', cart: restored, displaced: true };
                });
              }
              return { status: 'pending', cart: cart, code: code, reason: why };
            }

            // Cart meets every condition and it still didn't take — bad code.
            // Don't leave it sitting on the cart looking like it might work.
            var restore = prev.length ? prev[0] : '';
            return putDiscount(restore).then(function (restored) {
              return { status: 'rejected', cart: restored, displaced: prev.length > 0 };
            });
          });
        });
    },
    remove: function () {
      return putDiscount('').then(function (cart) { return { status: 'none', cart: cart }; });
    }
  };

  function setDiscMsg(text, kind) {
    if (!discMsg) return;
    discMsg.classList.remove('show', 'is-info');
    if (!text) return;
    discMsg.textContent = text;
    if (kind === 'info') discMsg.classList.add('is-info');
    discMsg.classList.add('show');
  }

  function renderDiscount(cart) {
    if (!discTag || !discForm) return;
    var st = discountState(cart);

    if (st.status === 'applied') {
      discCode.textContent = st.code;
      discAmt.textContent = '− ' + money(st.amount);
      discTag.classList.remove('is-pending');
      discTag.classList.add('show');
      discForm.style.display = 'none';
      setDiscMsg('');
    } else if (st.status === 'pending') {
      // Shopify is holding the code and will apply it the moment the cart
      // qualifies, so say what's missing rather than treating it as a failure.
      discCode.textContent = st.code;
      discAmt.textContent = 'Not applied yet';
      discTag.classList.add('is-pending', 'show');
      discForm.style.display = 'none';
      setDiscMsg(pendingReason(cart) || '', 'info');
    } else {
      discTag.classList.remove('show', 'is-pending');
      discForm.style.display = '';
      setDiscMsg('');
    }
    if (discInput) discInput.value = '';
  }

  if (discForm) {
    discForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var code = discInput.value;
      if (!code.trim()) return;
      discBtn.disabled = true;
      setDiscMsg('');
      window.nbDiscount.apply(code).then(function (res) {
        discBtn.disabled = false;
        if (res.cart) { renderCart(res.cart); syncBubble(res.cart); }
        if (res.status === 'rejected') {
          // renderCart has just repainted, so this message goes on last.
          setDiscMsg(res.displaced
            ? "That code didn't apply, so your existing discount has been kept."
            : "We couldn't find that code. Check the spelling and try again.");
        }
      }).catch(function () {
        discBtn.disabled = false;
        setDiscMsg('Something went wrong. Please try again.');
      });
    });
  }
  if (discRemove) {
    discRemove.addEventListener('click', function () {
      window.nbDiscount.remove().then(function (res) {
        renderCart(res.cart); syncBubble(res.cart);
      }).catch(function () {});
    });
  }

  if (cartItems) {
    cartItems.addEventListener('click', function (e) {
      var btn = e.target.closest('button'); if (!btn) return;
      var act = btn.getAttribute('data-act');
      if (act === 'inc' || act === 'dec') {
        var row = btn.closest('.nbci');
        var n = parseInt(row.querySelector('.nbci-n').textContent, 10) || 1;
        changeLine(row.getAttribute('data-key'), act === 'inc' ? n + 1 : n - 1);
      } else if (btn.classList.contains('nbcart-upadd')) {
        var vid = parseInt(btn.getAttribute('data-vid'), 10);
        btn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: vid, quantity: 1 })
        }).then(function () { return fetchCart(); }).catch(function () { btn.disabled = false; });
      }
    });
  }

  window.nbOpenCart = function () { nbHideToast(); open('nbCart', true); fetchCart(); };
  window.nbCartRefresh = fetchCart;

  // ---------- SHEETS: drag the grab handle to dismiss (mobile) ----------
  // dir 'down' for sheets anchored to the bottom (cart, notify); 'up' for the
  // search overlay, which hangs from the top so the natural gesture is upward.
  function makeSheetDraggable(panel, target, handles, dir) {
    if (!panel || !target) return;
    var up = dir === 'up';
    var startY = 0, curY = 0, dragging = false;
    function isSheet() { return window.matchMedia('(max-width: 749px)').matches; }
    function pointY(e) { return e.touches && e.touches.length ? e.touches[0].clientY : e.clientY; }
    function offset() {
      var raw = curY - startY;
      return up ? Math.min(0, raw) : Math.max(0, raw);
    }
    function onStart(e) {
      if (!isSheet() || !panel.classList.contains('is-open')) return;
      dragging = true;
      startY = curY = pointY(e);
      target.style.transition = 'none';
    }
    function onMove(e) {
      if (!dragging) return;
      curY = pointY(e);
      var dy = offset();
      target.style.transform = 'translateY(' + dy + 'px)';
      if (dy !== 0 && e.cancelable) e.preventDefault();
    }
    function onEnd() {
      if (!dragging) return;
      dragging = false;
      var dy = offset();
      target.style.transition = '';
      target.style.transform = '';
      if (Math.abs(dy) > 100) { close(); }
    }
    handles.forEach(function (h) {
      if (!h) return;
      h.addEventListener('touchstart', onStart, { passive: true });
      h.addEventListener('mousedown', onStart);
    });
    window.addEventListener('touchmove', onMove, { passive: false });
    window.addEventListener('mousemove', onMove);
    window.addEventListener('touchend', onEnd);
    window.addEventListener('touchcancel', onEnd);
    window.addEventListener('mouseup', onEnd);
  }
  var cartEl = $('nbCart');
  if (cartEl) makeSheetDraggable(cartEl, cartEl, [$('nbCartGrab'), cartEl.querySelector('.nbcart-head')]);
  var notifyEl = $('nbNotify');
  if (notifyEl) makeSheetDraggable(notifyEl, notifyEl.querySelector('.nbnotify-box'), [$('nbNotifyGrab')]);

  // ---------- ADD-TO-CART TOAST ----------
  var toast = $('nbToast'), toastTimer;
  function nbHideToast() { if (toast) toast.classList.remove('is-open'); clearTimeout(toastTimer); }
  window.nbToast = function (sub) {
    if (!toast) return;
    var s = $('nbToastSub');
    if (s) s.textContent = sub || '';
    toast.classList.add('is-open');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(nbHideToast, 4000);
    // keep the header cart bubble in sync
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); }).then(syncBubble).catch(function () {});
  };

  // ---------- WHATSAPP FLOATER: fade out over the footer (and any other
  // text-bearing fixed-bottom region) so it never sits on top of copy ----------
  var waFloat = document.querySelector('.nb-wa-float');
  var noOverlapEls = document.querySelectorAll('footer');
  if (waFloat && noOverlapEls.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      var anyVisible = entries.some(function (e) { return e.isIntersecting; });
      waFloat.classList.toggle('nb-wa-hide', anyVisible);
      // don't leave the chat panel floating once its button has gone
      if (anyVisible) waOpen(false);
    }, { threshold: 0, rootMargin: '0px 0px -40px 0px' });
    noOverlapEls.forEach(function (el) { io.observe(el); });
  }
  // ---------- WHATSAPP CHAT PANEL ----------
  // Clicking the floater opens a WhatsApp-styled form instead of jumping straight
  // to wa.me. Sending hands off to WhatsApp with the message already written.
  var waPanel = $('nbWaPanel');
  var waForm = $('nbWaForm');
  function waOpen(on) {
    if (!waPanel) return;
    waPanel.classList.toggle('is-open', on);
    // swap the launcher glyph to a cross while the panel is up
    if (waFloat) {
      waFloat.classList.toggle('nb-wa-open', on);
      waFloat.setAttribute('aria-label', on ? 'Close chat' : 'Chat with us on WhatsApp');
    }
    if (on) {
      var name = $('nbWaName');
      // don't steal focus on touch — it would pop the keyboard over the panel
      if (name && !window.matchMedia('(max-width: 749px)').matches) name.focus();
    }
  }
  if (waFloat && waPanel) {
    waFloat.addEventListener('click', function (e) {
      e.preventDefault(); // the href stays a working wa.me link if JS never runs
      waOpen(!waPanel.classList.contains('is-open'));
    });
  }
  var waClose = $('nbWaClose');
  if (waClose) waClose.addEventListener('click', function () { waOpen(false); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && waPanel && waPanel.classList.contains('is-open')) waOpen(false);
  });
  // tapping anywhere outside the panel (other than the floater) dismisses it
  document.addEventListener('click', function (e) {
    if (!waPanel || !waPanel.classList.contains('is-open')) return;
    if (waPanel.contains(e.target) || (waFloat && waFloat.contains(e.target))) return;
    waOpen(false);
  });
  // Reference code stamped into the WhatsApp message so an enquiry can be quoted
  // back later. Generated here, in the browser, so there is no request to wait on
  // — the code exists before WhatsApp opens. It is a reference, NOT a ticket: it
  // is not sequential (that needs a shared server-side counter) and nothing is
  // recorded anywhere unless the customer actually sends the message.
  // Local date, not toISOString(), so the stamp matches the customer's own day.
  function waRef() {
    var d = new Date();
    var pad = function (n) { return n < 10 ? '0' + n : '' + n; };
    var stamp = String(d.getFullYear()).slice(2) + pad(d.getMonth() + 1) + pad(d.getDate());
    // I and O are omitted so the code can't be misread as 1 or 0 over the phone
    var chars = '0123456789ABCDEFGHJKLMNPQRSTUVWXYZ';
    var buf = (window.crypto && window.crypto.getRandomValues)
      ? window.crypto.getRandomValues(new Uint8Array(5)) : null;
    var tail = '';
    for (var i = 0; i < 5; i++) {
      var v = buf ? buf[i] : Math.floor(Math.random() * 256);
      tail += chars.charAt(v % chars.length);
    }
    return 'NB-' + stamp + '-' + tail;
  }
  if (waForm) {
    waForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var number = waForm.getAttribute('data-wa-number');
      var name = ($('nbWaName').value || '').trim();
      var email = ($('nbWaEmail').value || '').trim();
      var msg = ($('nbWaMsg').value || '').trim();
      // name / email / message are mandatory; the consent tickbox is not, and its
      // state is deliberately not carried into the message
      if (!name || !email || !msg) return;
      // one code, used for both the silent log and the message, so they match
      var ticket = waRef();
      // Log to Zoho first, then hand off. The iframe POST keeps running across the
      // window.open, so nothing is lost — and the record exists even if the
      // customer never presses send in WhatsApp.
      var logForm = $('nbWaLog');
      if (logForm) {
        $('nbWaLogTicket').value = ticket;
        $('nbWaLogName').value = name;
        $('nbWaLogEmail').value = email;
        $('nbWaLogMsg').value = msg;
        // consent is given by the act of sending — the panel states it above the
        // send button, so every logged row is a consented one
        $('nbWaLogConsent').value = 'Yes';
        $('nbWaLogPage').value = location.pathname + location.search;
        try { logForm.submit(); } catch (err) { /* never block the handoff */ }
      }
      // newlines survive the handoff as %0A once encoded below
      var text = 'Hey!\nI am ' + name + '\nmy email is ' + email
               + '\nTicket no.: ' + ticket + '\n' + msg;
      window.open('https://wa.me/' + number + '?text=' + encodeURIComponent(text), '_blank', 'noopener');
      waForm.reset();
      waOpen(false);
    });
  }

  // Auto "peek": show the Support bubble briefly on page load, then let it
  // fade away on its own (works the same on mobile and desktop, since mobile
  // has no real hover to reveal it otherwise).
  if (waFloat) {
    setTimeout(function () {
      if (waFloat.classList.contains('nb-wa-hide')) return; // don't peek while over the footer
      waFloat.classList.add('nb-wa-peek');
      setTimeout(function () { waFloat.classList.remove('nb-wa-peek'); }, 3200);
    }, 1200);
  }
})();
